import { render, staticRenderFns } from "./InvoiceExtraHeaders.vue?vue&type=template&id=0365fca4&scoped=true"
import script from "./InvoiceExtraHeaders.vue?vue&type=script&lang=js"
export * from "./InvoiceExtraHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0365fca4",
  null
  
)

export default component.exports